<div class="field-container-file">
  <mat-form-field appearance="outline" class="field-control w-100" (click)="onClick()">
    <mat-label>{{ label }}</mat-label>

    @if (mode !== 'big' && source) {
      <span matTextPrefix>
        <img class="option-image-selected" [src]="source" />
      </span>
    }

    <input
      matInput
      [value]="name || ''"
      [placeholder]="placeholder || ''"

      (focus)="onFocus()"
      (blur)="onBlur()"
      (keyup)="onChange($event)"

      type="text"
    />

    @if ( mode === 'big' && source) {
      <div align="center" class="m-20">
        <img class="option-image-selected" [src]="source" style="width: 50%; height: 200px" />

      </div>
    }
    <mat-hint class="error-hint">
      @for (error of errors; track error) {
        <span class="bg-warning-500 text-white">
          {{ error.message }}
        </span>
      }
    </mat-hint>


  </mat-form-field>

  <input
    #inputFile
    class="field-input-file"
    type="file"
    accept=".jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*"

    (change)="onChange($event)"

  />
</div>


